(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-plan-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenFlickityReady(callback) {
      if (typeof Flickity === 'function') {
        callback();
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof Flickity === 'function') {
          clearInterval(timer);
          callback();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }

    function initGallery(root) {
      var main = root.querySelector('[data-fpv2-main]');
      if (!main || root.getAttribute('data-fpv2-ready') === 'true') return;
      if (main.querySelectorAll('.featured-product-v2__slide').length < 2) {
        root.setAttribute('data-fpv2-ready', 'true');
        return;
      }

      var flkty = new Flickity(main, {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: false,
        dragThreshold: 8,
        cellAlign: 'left',
        contain: true,
        percentPosition: false,
      });

      requestAnimationFrame(function () {
        flkty.resize();
      });

      var thumbs = root.querySelectorAll('[data-fpv2-thumb]');
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          flkty.select(index);
        });
      });

      flkty.on('select', function () {
        thumbs.forEach(function (thumb, index) {
          thumb.classList.toggle('is-selected', index === flkty.selectedIndex);
        });
      });

      root.setAttribute('data-fpv2-ready', 'true');
    }

    function initTabs(scope) {
      scope.querySelectorAll('[data-fpv2-tab]').forEach(function (button) {
        if (button.getAttribute('data-fpv2-bound') === 'true') return;
        button.setAttribute('data-fpv2-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.featured-product-v2__tab');
          var inner = tab.querySelector('.featured-product-v2__tab-inner');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          scope.querySelectorAll('.featured-product-v2__tab').forEach(function (other) {
            var otherButton = other.querySelector('[data-fpv2-tab]');
            var otherInner = other.querySelector('.featured-product-v2__tab-inner');
            otherButton.setAttribute('aria-expanded', 'false');
            otherInner.style.maxHeight = null;
          });

          if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });
    }

    function initForms(scope) {
      scope.querySelectorAll('[data-fpv2-form]').forEach(function (form) {
        if (form.getAttribute('data-fpv2-bound') === 'true') return;
        form.setAttribute('data-fpv2-bound', 'true');
        form.addEventListener('submit', function (event) {
          var button = form.querySelector('[data-fpv2-atc]');
          if (!button) return;
          event.preventDefault();
          button.setAttribute('disabled', 'disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          var payload = {};
          var allowed = { id: true, quantity: true, selling_plan: true };
          new FormData(form).forEach(function (value, key) {
            if (!allowed[key]) return;
            if (key === 'selling_plan' && !value) return;
            if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
              payload[key] = parseInt(value, 10);
            } else {
              payload[key] = value;
            }
          });

          var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
            .then(function (response) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
              if (response.ok) {
                form.dispatchEvent(
                  new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      quantity: parseInt(payload.quantity || '1', 10),
                    },
                  })
                );
              } else {
                return response.json().then(function (content) {
                  var error = document.createElement('span');
                  error.className = 'featured-product-v2__error';
                  error.textContent = content.description || 'Unable to add to cart';
                  button.insertAdjacentElement('afterend', error);
                  setTimeout(function () {
                    error.remove();
                  }, 2500);
                });
              }
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
            });
        });
      });
    }

    function fpv2ParseItems(raw) {
      try {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    // Reuses the site's existing /cart/add.js + cart:refresh conventions (window.PiqueCart,
    // defined in cart-drawer.js) when available, so plan-card adds get the same sidebar-open
    // / discount-code / recalc behavior as every other add-to-cart path on the site. Falls
    // back to a plain fetch if that global isn't present.
    function fpv2AddItems(items) {
      if (window.PiqueCart && typeof window.PiqueCart.addBundleToCartHome === 'function') {
        window.PiqueCart.addBundleToCartHome(items);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function(err) { console.error('Add to cart failed:', err); });
    }

    function initPlanSelector(scope) {
      scope.querySelectorAll('[data-fpv2-plans]').forEach(function(plansRoot) {
        if (plansRoot.getAttribute('data-fpv2-plans-bound') === 'true') return;
        plansRoot.setAttribute('data-fpv2-plans-bound', 'true');

        var plans = plansRoot.querySelectorAll('[data-fpv2-plan]');
        var bundleParent = plansRoot.getAttribute('data-bundle-parent');

        function selectPlan(radio) {
          plans.forEach(function(plan) { plan.classList.remove('is-selected'); });
          var plan = radio.closest('[data-fpv2-plan]');
          if (plan) plan.classList.add('is-selected');
        }

        plans.forEach(function(plan) {
          plan.addEventListener('click', function(e) {
            if (e.target.matches('[data-fpv2-plan-radio]')) return;
            var radio = plan.querySelector('[data-fpv2-plan-radio]');
            if (radio && !radio.checked) {
              radio.checked = true;
              selectPlan(radio);
            }
          });
        });
        plansRoot.querySelectorAll('[data-fpv2-plan-radio]').forEach(function(radio) {
          radio.addEventListener('change', function() { selectPlan(radio); });
        });

        function getSelectedPlan() {
          var checked = plansRoot.querySelector('[data-fpv2-plan-radio]:checked');
          return checked ? checked.closest('[data-fpv2-plan]') : null;
        }

        // The Add to Cart / Buy Once buttons render right after this plans group in the
        // markup (see the plan_option case in the Liquid above), so look for them as siblings.
        var actions = plansRoot.nextElementSibling;
        var addBtn = actions && actions.querySelector('[data-fpv2-plan-atc]');
        var buyOnceLink = actions && actions.querySelector('[data-fpv2-plan-buy-once]');

        if (addBtn) {
          addBtn.addEventListener('click', function() {
            var plan = getSelectedPlan();
            if (!plan) return;

            var baseItems = fpv2ParseItems(plan.getAttribute('data-items'));
            var giftIdsRaw = plan.getAttribute('data-gift-ids');
            if (!baseItems.length) return;

            var giftGroupId = 'fpv2-' + Date.now();
            var bundleGroupId = bundleParent ? ('fpv2-bundle-' + Date.now()) : null;

            var items = baseItems.map(function(it) {
              var properties = { _no_discount: 'true', _fpv2_gift_group: giftGroupId };
              if (bundleParent) {
                properties._bundle_parent = bundleParent;
                properties._bundle_id = bundleGroupId;
              }
              var item = { id: it.id, quantity: it.quantity || 1, properties: properties };
              if (it.selling_plan) item.selling_plan = it.selling_plan;
              return item;
            });

            if (giftIdsRaw) {
              giftIdsRaw.split(',').forEach(function(idStr) {
                var giftId = Number(idStr);
                if (!giftId) return;
                items.push({
                  id: giftId,
                  quantity: 1,
                  properties: { _free_gift_with_order: 'true', _fpv2_gift_group: giftGroupId }
                });
              });
            }

            // window.PiqueCart.addBundleToCartHome already checks for _bundle_parent ===
            // 50583489708130 on subscribed items and applies 25OFFSUB itself — nothing
            // extra needed here for that.
            fpv2AddItems(items);
          });
        }

        if (buyOnceLink) {
          buyOnceLink.addEventListener('click', function(e) {
            e.preventDefault();
            var items = fpv2ParseItems(buyOnceLink.getAttribute('data-buy-once-items'));
            if (!items.length) return;
            // One-time purchase: no selling plan, no bundle tagging, no gifts.
            fpv2AddItems(items.map(function(it) { return { id: it.id, quantity: it.quantity || 1 }; }));
          });
        }
      });
    }

    function initTierSelector(scope) {
      scope.querySelectorAll('[data-fpv2-tiers]').forEach(function(tiersRoot) {
        if (tiersRoot.getAttribute('data-fpv2-tiers-bound') === 'true') return;
        tiersRoot.setAttribute('data-fpv2-tiers-bound', 'true');

        var tiers = tiersRoot.querySelectorAll('[data-fpv2-tier]');
        var actions = tiersRoot.nextElementSibling;
        var addBtn = actions && actions.querySelector('[data-fpv2-tier-atc]');
        var addBtnLabel = actions && actions.querySelector('[data-fpv2-tier-atc-label]');
        var addBtnPrice = actions && actions.querySelector('[data-fpv2-tier-atc-price]');

        function updateCtaLabel(tier) {
          if (!addBtnLabel) return;
          addBtnLabel.textContent = tier.getAttribute('data-cta-text') || 'ADD TO CART';
        }

        console.log(addBtnPrice);

        function updatePriceDisplay(tier) {    
      if (!addBtnPrice) return;
      addBtnPrice.textContent = tier.getAttribute('data-price-display') || '';
    }

        function selectTier(radio) {
          tiers.forEach(function(tier) { tier.classList.remove('is-selected'); });
          var tier = radio.closest('[data-fpv2-tier]');
          if (tier) {
            tier.classList.add('is-selected');
            updateCtaLabel(tier);
            updatePriceDisplay(tier);   
          }
        }

        tiers.forEach(function(tier) {
          tier.addEventListener('click', function(e) {
            if (e.target.matches('[data-fpv2-tier-radio]')) return;
            var radio = tier.querySelector('[data-fpv2-tier-radio]');
            if (radio && !radio.checked) {
              radio.checked = true;
              selectTier(radio);
            }
          });
        });
        tiersRoot.querySelectorAll('[data-fpv2-tier-radio]').forEach(function(radio) {
          radio.addEventListener('change', function() { selectTier(radio); });
        });

        function getSelectedTier() {
          var checked = tiersRoot.querySelector('[data-fpv2-tier-radio]:checked');
          return checked ? checked.closest('[data-fpv2-tier]') : null;
        }

        // Set the initial CTA label to match whichever tier is preselected on page load.
        var initialTier = getSelectedTier();
        if (initialTier) {
          updateCtaLabel(initialTier);
          updatePriceDisplay(initialTier);   // ← add this line too
        }

        if (addBtn) {
          addBtn.addEventListener('click', function() {
            var tier = getSelectedTier();
            if (!tier) return;

            var baseItems = fpv2ParseItems(tier.getAttribute('data-items'));
            if (!baseItems.length) return;

            var bundleParent = tier.getAttribute('data-bundle-parent');
            var bundleGroupId = bundleParent ? ('fpv2-tier-' + Date.now()) : null;

            // No gift items are added here — cart-drawer.js's own gift logic grants the
            // right gift (if any) once it sees these components' _bundle_parent, exactly
            // the same way it already does for the existing SHLP/RSD/DHP bundles.
            var items = baseItems.map(function(it) {
              var properties = { _no_discount: 'true' };
              if (bundleParent) {
                properties._bundle_parent = bundleParent;
                properties._bundle_id = bundleGroupId;
              }
              var item = { id: it.id, quantity: it.quantity || 1, properties: properties };
              if (it.selling_plan) item.selling_plan = it.selling_plan;
              return item;
            });

            fpv2AddItems(items);
          });
        }
      });
    }

    // Stray-gift cleanup: if the paid item from a _fpv2_gift_group add is later removed from
    // the cart, drop its free gifts too. Global (not per-section), runs on the same
    // cart:refresh event the rest of the site's cart script already dispatches.
    var fpv2CleanupRunning = false;
    function fpv2CleanupStrayGifts() {
      if (fpv2CleanupRunning) return;
      fpv2CleanupRunning = true;
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var groups = {};
        cart.items.forEach(function(item) {
          var group = item.properties && item.properties._fpv2_gift_group;
          if (!group) return;
          var isGift = item.properties._free_gift_with_order === 'true';
          groups[group] = groups[group] || { hasPaidItem: false, giftLines: [] };
          if (isGift) {
            groups[group].giftLines.push(item);
          } else {
            groups[group].hasPaidItem = true;
          }
        });

        var updates = {};
        Object.keys(groups).forEach(function(group) {
          if (!groups[group].hasPaidItem) {
            groups[group].giftLines.forEach(function(line) { updates[line.id] = 0; });
          }
        });

        if (Object.keys(updates).length === 0) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      }).catch(function(err) { console.error('Gift cleanup failed:', err); })
        .finally(function() { fpv2CleanupRunning = false; });
    }
    document.documentElement.addEventListener('cart:refresh', fpv2CleanupStrayGifts);

    function initReviewJump(scope) {
      scope.querySelectorAll('.okeReviews-reviewsCarousel-btn').forEach(function (button) {
        if (button.getAttribute('data-fpv2-reviews-bound') === 'true') return;
        button.setAttribute('data-fpv2-reviews-bound', 'true');
        button.addEventListener('click', function (event) {
          var target = document.querySelector('[data-oke-widget]');
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    // Keep the sticky gallery below whatever fixed/sticky header covers the top of the viewport
    function updateStickyTop() {
      var offset = 0;
      document.elementsFromPoint(5, 1).forEach(function (el) {
        for (var node = el; node && node !== document.body; node = node.parentElement) {
          if (node.closest('.featured-product-v2')) break;
          var position = window.getComputedStyle(node).position;
          if (position === 'fixed' || position === 'sticky') {
            offset = Math.max(offset, node.getBoundingClientRect().bottom);
            break;
          }
        }
      });
      document.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        sectionRoot.style.setProperty('--fpv2-sticky-top', Math.round(offset) + 20 + 'px');
      });
    }

    var stickyTicking = false;
    function requestStickyTop() {
      if (stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(function () {
        stickyTicking = false;
        updateStickyTop();
      });
    }

    window.addEventListener('scroll', requestStickyTop, { passive: true });
    window.addEventListener('resize', requestStickyTop);
    window.addEventListener('load', requestStickyTop);

    function init(scope) {
      var root = scope || document;
      requestStickyTop();
      whenFlickityReady(function () {
        root.querySelectorAll('[data-fpv2-gallery]').forEach(initGallery);
      });
      root.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
        initForms(sectionRoot);
        initReviewJump(sectionRoot);
        initPlanSelector(sectionRoot);
        initTierSelector(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  (function () {
    var STICKY_TOP_SELECTORS = [
      '#shopify-section-announcement',
      '#shopify-section-announcement-lp',
      '.shopify-section--header',
      '#shopify-section-RadinatHome-Header'
    ];

    var pinnedElements = [];
    function collectPinnedElements() {
      var elements = [];
      STICKY_TOP_SELECTORS.forEach(function (selector) {
        var el = document.querySelector(selector);
        if (el) elements.push(el);
      });
      var reploRoot = document.getElementById('replo-fullpage-element');
      if (reploRoot) {
        reploRoot.querySelectorAll('*').forEach(function (el) {
          if (el.closest('.featured-product-v2') || el.querySelector('.featured-product-v2')) return;
          var style = window.getComputedStyle(el);
          if (style.position !== 'fixed' && style.position !== 'sticky') return;
          if (style.top === 'auto' || parseFloat(style.top) > 0) return;
          elements.push(el);
        });
      }
      pinnedElements = elements;
    }

    function updateStickyOffset() {
      var offset = 0;
      var maxHeight = window.innerHeight * 0.4;
      pinnedElements.forEach(function (el) {
        if (!el.isConnected || !el.offsetHeight || el.offsetHeight > maxHeight) return;
        var style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        offset = Math.max(offset, (parseFloat(style.top) || 0) + el.offsetHeight);
      });
      document.documentElement.style.setProperty('--fp-v2-sticky-offset', offset + 'px');
    }

    function initStickyOffset() {
      collectPinnedElements();
      updateStickyOffset();
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(updateStickyOffset);
        pinnedElements.forEach(function (el) {
          observer.observe(el);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyOffset);
    } else {
      initStickyOffset();
    }
    window.addEventListener('load', updateStickyOffset);
    window.addEventListener('resize', updateStickyOffset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(scope) {
      var root = scope.querySelector('[data-ee-faq]') || scope;
      if (!root || root.getAttribute('data-ee-faq-ready') === 'true') return;

      root.querySelectorAll('[data-ee-faq-tab]').forEach(function (button) {
        if (button.getAttribute('data-ee-faq-bound') === 'true') return;
        button.setAttribute('data-ee-faq-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.ee-faq__item');
          var inner = tab.querySelector('.ee-faq__inner-panel');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          root.querySelectorAll('.ee-faq__item').forEach(function (other) {
            var otherButton = other.querySelector('[data-ee-faq-tab]');
            var otherInner = other.querySelector('.ee-faq__inner-panel');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            if (otherInner) otherInner.style.maxHeight = null;
          });

          if (!isOpen && inner) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });

      root.setAttribute('data-ee-faq-ready', 'true');
    }

    function init(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-ee-faq]').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionRoot = event.target.querySelector('[data-ee-faq]');
      if (sectionRoot) sectionRoot.removeAttribute('data-ee-faq-ready');
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-featured-product-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenFlickityReady(callback) {
      if (typeof Flickity === 'function') {
        callback();
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof Flickity === 'function') {
          clearInterval(timer);
          callback();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }

    function initGallery(root) {
      var main = root.querySelector('[data-fpv2-main]');
      if (!main || root.getAttribute('data-fpv2-ready') === 'true') return;
      if (main.querySelectorAll('.featured-product-v2__slide').length < 2) {
        root.setAttribute('data-fpv2-ready', 'true');
        return;
      }

      var flkty = new Flickity(main, {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: false,
        dragThreshold: 8,
        cellAlign: 'left',
        contain: true,
        percentPosition: false,
      });

      requestAnimationFrame(function () {
        flkty.resize();
      });

      var thumbs = root.querySelectorAll('[data-fpv2-thumb]');
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          flkty.select(index);
        });
      });

      flkty.on('select', function () {
        thumbs.forEach(function (thumb, index) {
          thumb.classList.toggle('is-selected', index === flkty.selectedIndex);
        });
      });

      root.setAttribute('data-fpv2-ready', 'true');
    }

    function initTabs(scope) {
      scope.querySelectorAll('[data-fpv2-tab]').forEach(function (button) {
        if (button.getAttribute('data-fpv2-bound') === 'true') return;
        button.setAttribute('data-fpv2-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.featured-product-v2__tab');
          var inner = tab.querySelector('.featured-product-v2__tab-inner');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          scope.querySelectorAll('.featured-product-v2__tab').forEach(function (other) {
            var otherButton = other.querySelector('[data-fpv2-tab]');
            var otherInner = other.querySelector('.featured-product-v2__tab-inner');
            otherButton.setAttribute('aria-expanded', 'false');
            otherInner.style.maxHeight = null;
          });

          if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });
    }

    function initForms(scope) {
      scope.querySelectorAll('[data-fpv2-form]').forEach(function (form) {
        if (form.getAttribute('data-fpv2-bound') === 'true') return;
        form.setAttribute('data-fpv2-bound', 'true');
        form.addEventListener('submit', function (event) {
          var button = form.querySelector('[data-fpv2-atc]');
          if (!button) return;
          event.preventDefault();
          button.setAttribute('disabled', 'disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          var payload = {};
          var allowed = { id: true, quantity: true, selling_plan: true };
          new FormData(form).forEach(function (value, key) {
            if (!allowed[key]) return;
            if (key === 'selling_plan' && !value) return;
            if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
              payload[key] = parseInt(value, 10);
            } else {
              payload[key] = value;
            }
          });

          var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
            .then(function (response) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
              if (response.ok) {
                form.dispatchEvent(
                  new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      quantity: parseInt(payload.quantity || '1', 10),
                    },
                  })
                );
              } else {
                return response.json().then(function (content) {
                  var error = document.createElement('span');
                  error.className = 'featured-product-v2__error';
                  error.textContent = content.description || 'Unable to add to cart';
                  button.insertAdjacentElement('afterend', error);
                  setTimeout(function () {
                    error.remove();
                  }, 2500);
                });
              }
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
            });
        });
      });
    }

    function initReviewJump(scope) {
      scope.querySelectorAll('.okeReviews-reviewsCarousel-btn').forEach(function (button) {
        if (button.getAttribute('data-fpv2-reviews-bound') === 'true') return;
        button.setAttribute('data-fpv2-reviews-bound', 'true');
        button.addEventListener('click', function (event) {
          var target = document.querySelector('[data-oke-widget]');
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    // Keep the sticky gallery below whatever fixed/sticky header covers the top of the viewport
    function updateStickyTop() {
      var offset = 0;
      document.elementsFromPoint(5, 1).forEach(function (el) {
        for (var node = el; node && node !== document.body; node = node.parentElement) {
          if (node.closest('.featured-product-v2')) break;
          var position = window.getComputedStyle(node).position;
          if (position === 'fixed' || position === 'sticky') {
            offset = Math.max(offset, node.getBoundingClientRect().bottom);
            break;
          }
        }
      });
      document.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        sectionRoot.style.setProperty('--fpv2-sticky-top', Math.round(offset) + 20 + 'px');
      });
    }

    var stickyTicking = false;
    function requestStickyTop() {
      if (stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(function () {
        stickyTicking = false;
        updateStickyTop();
      });
    }

    window.addEventListener('scroll', requestStickyTop, { passive: true });
    window.addEventListener('resize', requestStickyTop);
    window.addEventListener('load', requestStickyTop);

    function init(scope) {
      var root = scope || document;
      requestStickyTop();
      whenFlickityReady(function () {
        root.querySelectorAll('[data-fpv2-gallery]').forEach(initGallery);
      });
      root.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
        initForms(sectionRoot);
        initReviewJump(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  (function () {
    var STICKY_TOP_SELECTORS = [
      '#shopify-section-announcement',
      '#shopify-section-announcement-lp',
      '.shopify-section--header',
      '#shopify-section-RadinatHome-Header'
    ];

    var pinnedElements = [];
    function collectPinnedElements() {
      var elements = [];
      STICKY_TOP_SELECTORS.forEach(function (selector) {
        var el = document.querySelector(selector);
        if (el) elements.push(el);
      });
      var reploRoot = document.getElementById('replo-fullpage-element');
      if (reploRoot) {
        reploRoot.querySelectorAll('*').forEach(function (el) {
          if (el.closest('.featured-product-v2') || el.querySelector('.featured-product-v2')) return;
          var style = window.getComputedStyle(el);
          if (style.position !== 'fixed' && style.position !== 'sticky') return;
          if (style.top === 'auto' || parseFloat(style.top) > 0) return;
          elements.push(el);
        });
      }
      pinnedElements = elements;
    }

    function updateStickyOffset() {
      var offset = 0;
      var maxHeight = window.innerHeight * 0.4;
      pinnedElements.forEach(function (el) {
        if (!el.isConnected || !el.offsetHeight || el.offsetHeight > maxHeight) return;
        var style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        offset = Math.max(offset, (parseFloat(style.top) || 0) + el.offsetHeight);
      });
      document.documentElement.style.setProperty('--fp-v2-sticky-offset', offset + 'px');
    }

    function initStickyOffset() {
      collectPinnedElements();
      updateStickyOffset();
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(updateStickyOffset);
        pinnedElements.forEach(function (el) {
          observer.observe(el);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyOffset);
    } else {
      initStickyOffset();
    }
    window.addEventListener('load', updateStickyOffset);
    window.addEventListener('resize', updateStickyOffset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-featured-product-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenFlickityReady(callback) {
      if (typeof Flickity === 'function') {
        callback();
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof Flickity === 'function') {
          clearInterval(timer);
          callback();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }

    function initGallery(root) {
      var main = root.querySelector('[data-fpv2-main]');
      if (!main || root.getAttribute('data-fpv2-ready') === 'true') return;
      if (main.querySelectorAll('.featured-product-v2__slide').length < 2) {
        root.setAttribute('data-fpv2-ready', 'true');
        return;
      }

      var flkty = new Flickity(main, {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: false,
        dragThreshold: 8,
        cellAlign: 'left',
        contain: true,
        percentPosition: false,
      });

      requestAnimationFrame(function () {
        flkty.resize();
      });

      var thumbs = root.querySelectorAll('[data-fpv2-thumb]');
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          flkty.select(index);
        });
      });

      flkty.on('select', function () {
        thumbs.forEach(function (thumb, index) {
          thumb.classList.toggle('is-selected', index === flkty.selectedIndex);
        });
      });

      root.setAttribute('data-fpv2-ready', 'true');
    }

    function initTabs(scope) {
      scope.querySelectorAll('[data-fpv2-tab]').forEach(function (button) {
        if (button.getAttribute('data-fpv2-bound') === 'true') return;
        button.setAttribute('data-fpv2-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.featured-product-v2__tab');
          var inner = tab.querySelector('.featured-product-v2__tab-inner');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          scope.querySelectorAll('.featured-product-v2__tab').forEach(function (other) {
            var otherButton = other.querySelector('[data-fpv2-tab]');
            var otherInner = other.querySelector('.featured-product-v2__tab-inner');
            otherButton.setAttribute('aria-expanded', 'false');
            otherInner.style.maxHeight = null;
          });

          if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });
    }

    function initForms(scope) {
      scope.querySelectorAll('[data-fpv2-form]').forEach(function (form) {
        if (form.getAttribute('data-fpv2-bound') === 'true') return;
        form.setAttribute('data-fpv2-bound', 'true');
        form.addEventListener('submit', function (event) {
          var button = form.querySelector('[data-fpv2-atc]');
          if (!button) return;
          event.preventDefault();
          button.setAttribute('disabled', 'disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          var payload = {};
          var allowed = { id: true, quantity: true, selling_plan: true };
          new FormData(form).forEach(function (value, key) {
            if (!allowed[key]) return;
            if (key === 'selling_plan' && !value) return;
            if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
              payload[key] = parseInt(value, 10);
            } else {
              payload[key] = value;
            }
          });

          var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
            .then(function (response) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
              if (response.ok) {
                form.dispatchEvent(
                  new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      quantity: parseInt(payload.quantity || '1', 10),
                    },
                  })
                );
              } else {
                return response.json().then(function (content) {
                  var error = document.createElement('span');
                  error.className = 'featured-product-v2__error';
                  error.textContent = content.description || 'Unable to add to cart';
                  button.insertAdjacentElement('afterend', error);
                  setTimeout(function () {
                    error.remove();
                  }, 2500);
                });
              }
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
            });
        });
      });
    }

    function initReviewJump(scope) {
      scope.querySelectorAll('.okeReviews-reviewsCarousel-btn').forEach(function (button) {
        if (button.getAttribute('data-fpv2-reviews-bound') === 'true') return;
        button.setAttribute('data-fpv2-reviews-bound', 'true');
        button.addEventListener('click', function (event) {
          var target = document.querySelector('[data-oke-widget]');
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    // Keep the sticky gallery below whatever fixed/sticky header covers the top of the viewport
    function updateStickyTop() {
      var offset = 0;
      document.elementsFromPoint(5, 1).forEach(function (el) {
        for (var node = el; node && node !== document.body; node = node.parentElement) {
          if (node.closest('.featured-product-v2')) break;
          var position = window.getComputedStyle(node).position;
          if (position === 'fixed' || position === 'sticky') {
            offset = Math.max(offset, node.getBoundingClientRect().bottom);
            break;
          }
        }
      });
      document.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        sectionRoot.style.setProperty('--fpv2-sticky-top', Math.round(offset) + 20 + 'px');
      });
    }

    var stickyTicking = false;
    function requestStickyTop() {
      if (stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(function () {
        stickyTicking = false;
        updateStickyTop();
      });
    }

    window.addEventListener('scroll', requestStickyTop, { passive: true });
    window.addEventListener('resize', requestStickyTop);
    window.addEventListener('load', requestStickyTop);

    function init(scope) {
      var root = scope || document;
      requestStickyTop();
      whenFlickityReady(function () {
        root.querySelectorAll('[data-fpv2-gallery]').forEach(initGallery);
      });
      root.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
        initForms(sectionRoot);
        initReviewJump(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  (function () {
    var STICKY_TOP_SELECTORS = [
      '#shopify-section-announcement',
      '#shopify-section-announcement-lp',
      '.shopify-section--header',
      '#shopify-section-RadinatHome-Header'
    ];

    var pinnedElements = [];

    function collectPinnedElements() {
      var elements = [];
      STICKY_TOP_SELECTORS.forEach(function (selector) {
        var el = document.querySelector(selector);
        if (el) elements.push(el);
      });
      var reploRoot = document.getElementById('replo-fullpage-element');
      if (reploRoot) {
        reploRoot.querySelectorAll('*').forEach(function (el) {
          if (el.closest('.featured-product-v2') || el.querySelector('.featured-product-v2')) return;
          var style = window.getComputedStyle(el);
          if (style.position !== 'fixed' && style.position !== 'sticky') return;
          if (style.top === 'auto' || parseFloat(style.top) > 0) return;
          elements.push(el);
        });
      }
      pinnedElements = elements;
    }

    function updateStickyOffset() {
      var offset = 0;
      var maxHeight = window.innerHeight * 0.4;
      pinnedElements.forEach(function (el) {
        if (!el.isConnected || !el.offsetHeight || el.offsetHeight > maxHeight) return;
        var style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        offset = Math.max(offset, (parseFloat(style.top) || 0) + el.offsetHeight);
      });
      document.documentElement.style.setProperty('--fp-v2-sticky-offset', offset + 'px');
    }

    function initStickyOffset() {
      collectPinnedElements();
      updateStickyOffset();
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(updateStickyOffset);
        pinnedElements.forEach(function (el) {
          observer.observe(el);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyOffset);
    } else {
      initStickyOffset();
    }
    window.addEventListener('load', updateStickyOffset);
    window.addEventListener('resize', updateStickyOffset);
  })();

  } catch(e) { console.error(e); }
})();
})();
